// @ts-nocheck
const getContenDispositionFilename = (contentDisposition: string | undefined | null) => {
    if (contentDisposition) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, "");
        }
    }

    return "";
};

export default getContenDispositionFilename;
